import React from 'react'
import 'animate.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import { ScrollToTop } from './components/common/scrollToTop/ScrollToTop'
import { Landing } from './pages/landing/Landing'
import { Dashboard } from './pages/dashboard/DashBoard'
import Sidebar from './components/common/sideBar/SideBar'
import { Inventory } from './pages/inventory/Inventory'
import { useSelector } from 'react-redux'
import { ProductDetails } from './pages/productDetails/ProductDetails'
import { EditProduct } from './pages/inventory/editProduct/EditProduct'
import { CustomerList } from './pages/customer/CustomerList'
import { CategoryList } from './pages/category/CategoryList'
import { CustomerDetails } from './pages/customerDetails/CustomerDetails'
import { EditCustomer } from './pages/customer/editCustomer/EditCustomer'
import { Orders } from './pages/order/orders/Orders'
import { OrderDetails } from './pages/order/orderDetails/OrderDetails'
import { ProtectedRoute } from './components/protectedRoute/ProtectedRoute'
import { UserList } from './pages/user/UserList'
import { UserDetails } from './components/user/userDetails/UserDetails'
import { AccountVerification } from './pages/accountVerification/AccountVerification'
import { UpdatePassword } from './pages/updatePassword/UpdatePassword'
import { ResetPassword } from './pages/resetPassword/ResetPassword'
import { Reporting } from './pages/reporting/Reporting'
import { Capital } from './pages/capital/Capital'
import { SpendingCategoryPage } from './pages/expense/spendingCategory/SpendingCategoryPage'
import { SpendingPage } from './pages/expense/SpendingPage'

function App() {
  const isLoggedIn = useSelector((state) => state.user?.info?.accessToken)
  //   const location = useLocation()
  // const hideFooterOnRoutes = ['/'] // Add more routes here if needed
  // const shouldShowFooter = !hideFooterOnRoutes.includes(location.pathname)

  return (
    <Router>
      <main>
        <div className='app-container'>
          {isLoggedIn && (
            <div className='sideBar'>
              <Sidebar />
            </div>
          )}
          <div className='main-content'>
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<Landing />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              <Route path='/update-password' element={<UpdatePassword />} />
              <Route
                path='/account-verification'
                element={<AccountVerification />}
              />
              <Route
                path='/dashboard'
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/reporting'
                element={
                  <ProtectedRoute>
                    <Reporting />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/order'
                element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/order/:orderId'
                element={
                  <ProtectedRoute>
                    <OrderDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/category'
                element={
                  <ProtectedRoute>
                    <CategoryList />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/inventory'
                element={
                  <ProtectedRoute>
                    <Inventory />
                  </ProtectedRoute>
                }
              />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route
                path='/edit-product/:productId'
                element={
                  <ProtectedRoute>
                    <EditProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/product/:productId'
                element={
                  <ProtectedRoute>
                    <ProductDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/customers'
                element={
                  <ProtectedRoute>
                    <CustomerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/customer/:customerId'
                element={
                  <ProtectedRoute>
                    <CustomerDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/edit-customer/:customerId'
                element={
                  <ProtectedRoute>
                    <EditCustomer />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/users'
                element={
                  <ProtectedRoute>
                    <UserList />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/user-details/:userId'
                element={
                  <ProtectedRoute>
                    <UserDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/capital'
                element={
                  <ProtectedRoute>
                    <Capital />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/spending-category'
                element={
                  <ProtectedRoute>
                    <SpendingCategoryPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/expense'
                element={
                  <ProtectedRoute>
                    <SpendingPage />
                  </ProtectedRoute>
                }
              />
              {/* --------------- available only before or after login -------------- */}
              {/* <Route
          path="/login"
          element={
            <ProtectedRouteWithoutLogin>
              <Login />
            </ProtectedRouteWithoutLogin>
          }
        /> */}
              {/* <Route
          path="/order-success"
          element={
            <ProtectedRoute>
              <OrderSuccess />
            </ProtectedRoute>
          }
        /> */}

              {/* <Route
          path="/login"
          element={
            <ProtectedRouteWithoutLogin>
              <Login />
            </ProtectedRouteWithoutLogin>
          }
        /> */}
            </Routes>
          </div>
          <footer className='footer bg-dark text-white text-center py-3 mt-auto'>
            <p className='mb-0'>
              © {new Date().getFullYear()} BusinessCorners. All rights reserved.
            </p>
          </footer>
        </div>
      </main>
    </Router>
  )
}

export default App
